// address-lookup-widget.js

// Assumes:
//  - input has [data-address-lookup] + required data-address-lookup-* attributes
//  - button/select ids are provided via attributes (do not hardcode ids)

(function ($) {


	//a tiny helper method to read the required attributess
	function requiredAttr($el, name) {
		var val = $el.attr(name);
		if (!val) {
			throw new Error("AddressLookup: missing required attribute " + name);
		}
		return val;
	}

  
  // 2920 - UPRN is the one target a form may legitimately not have reserved
  // a slot for (see CivicaAddressLookupButton#buildTargetMap). Its absence
  // must not blow up _create() for the whole widget.
  function optionalAttr($el, name) {
    return $el.attr(name) || null;
  }

  $.widget("civica.addressLookup", {
		options: {
			method: "POST",

			latSelector: "#Location\\.Latitude",
			lngSelector: "#Location\\.Longitude",
			
			pageSize: 20,
			scrollThresholdPx: 40,

			resultsClass: "address-lookup-results",
			resultClass: "address-lookup-result",
			loadingClass: "address-lookup-results-loading",			

			// optional hooks
			onError: function(err, ctx) {console.error(err)}
		},

		_create: function () {
			var $input = this.element;

			// Only initialise when we find a data-address-lookup attribute
			if (!$input.is("[data-address-lookup]")) return;

			
			//set the required attributes
			this.endpoint = requiredAttr($input, "data-address-lookup-endpoint");
			this.buttonId = requiredAttr($input, "data-address-lookup-button");
			this.selectId = requiredAttr($input, "data-address-lookup-options");

			this.targets = {
				addressLine: requiredAttr($input, "data-address-lookup-address-line"),
				town: requiredAttr($input, "data-address-lookup-town"),
				county: requiredAttr($input, "data-address-lookup-county"),
				postcode: requiredAttr($input, "data-address-lookup-postcode"),
				uprn: optionalAttr($input, "data-address-lookup-uprn"),
			};

			// --- Resolve DOM nodes from ids supplied by server
			this.$button = $("#" + this.buttonId);
			this.$select = $("#" + this.selectId);

			// If server DOM shape changes, fail without causing issues
			if (!this.$button.length || !this.$select.length) return;
			
			// Paging/search state
			this._results = [];
			this._currentPage = 0;
			this._hasMore = false;
			this._lastSearchPayload = null;
			this._isLoadingMore = false;
			this._activeRequest = null;

			// Creating custom infinite style scrollable results container
			this.$results = $('<div/>', {
				"class": this.options.resultsClass,
				"role": "listbox",
				"aria-label": "Address lookup results"
			});		
			
			// Placing the  custom list after the select, but keep the select for compatibility
			this.$results.insertAfter(this.$select);
			this.$results.hide();

			// Hiding the native select from the user
			this._hideSelect();				

			// --- Bind the events for the button and selecting the address
			this._on(this.$button, { click: "_handleFindAddressClick" });
			this._on(this.$select, { change: "_handleSelectAddressChange" });
			
			this._on(this.$results, {
				scroll: "_handleResultsScroll",
				"click .address-lookup-result": "_handleResultClick",
				"keydown .address-lookup-result": "_handleResultKeydown"
			});

			// Restore placeholder as soon as user types after validation message
			this._on(this.element, {
				input: function () {
					this._restorePlaceholder();
				}
			});			

			// Initial UI state
			this._setLoading(false);
			this._renderSelectOptions([]); // empty select
			this._hideResults();
			this._hideMessage();
		},

		_destroy: function () {
			if (this._activeRequest && this._activeRequest.readyState !== 4) {
				this._activeRequest.abort();
			}

			this._hideMessage();

			if (this.$results && this.$results.length) {
				this.$results.remove();
			}

			this._showSelect();			
		},
		

		_handleFindAddressClick: function (e) {
					e.preventDefault();
					
					// Abort previous request, if still running
					if (this._activeRequest && this._activeRequest.readyState !== 4) {
						this._activeRequest.abort();
					}					

					// Clear stale values + hide previous select/results
						this._clearTargets();
						this._hideSelect();
						this._renderSelectOptions([]);     // clears options
						this._hideMessage();         // clears any old message

						var self = this;
						var rawInput = $.trim(this.element.val() || "");
						if (!rawInput) {
							this._setPlaceholder("Enter a postcode or valid address");
							this.element.focus();
							return;
						}
						this._restorePlaceholder();
						var parsed = this._parseSearchInput(rawInput);

						var payload = {
							postcode: parsed.postcode,
							nameOrNumber: parsed.nameOrNumber
						};

						this._results = [];
						this._currentPage = 0;
						this._hasMore = false;
						this._lastSearchPayload = payload;
						this._isLoadingMore = false;

						this._search(payload, 0, false);						
	},
				
				
				_parseSearchInput: function (rawInput) {
					// This regex looks for a standard UK postcode format at the end of the string
					var postcodeRegex = /([A-Z]{1,2}[0-9][A-Z0-9]?\s?[0-9][A-Z]{2})$/i;
					var match = rawInput.match(postcodeRegex);

					var postcode = "";
					var nameOrNumber = "";

					if (match) {
						postcode = match[1];

						// Everything before the postcode is treated as the name or number
						nameOrNumber = $.trim(
							rawInput
								.replace(postcode, "")
								.replace(/,$/, "")
						);
					} else {
						postcode = rawInput;
					}

					return {
						postcode: postcode,
						nameOrNumber: nameOrNumber
					};
				},

				_search: function (payload, page, append) {
					var self = this;

					this._setLoading(true);
					this._setResultsLoading(true);

					var pagedPayload = $.extend({}, payload, {
						page: page,
						pageSize: this.options.pageSize
					});

					this._activeRequest = $.ajax({
						url: this.endpoint,
						method: this.options.method,
						dataType: "json",
						contentType: "application/json",
						data: JSON.stringify(pagedPayload)
					})
					.done(function (data) {
						var results = self._extractResults(data);

						self._hasMore = self._extractHasMore(data, results, page);
						self._currentPage = page;

						if (append) {
							self._results = self._results.concat(results);
						} else {
							self._results = results;
						}

						if (self._results && self._results.length) {
							self._hideMessage();
							self._renderSelectOptions(self._results);
							self._renderResultsList(self._results, self._hasMore);
							self._showResults();
						} else {
							self._clearTargets();
							self._renderSelectOptions([]);
							self._hideResults();
							self._showMessage("No matching addresses found.");
						}

						if (typeof self.options.onLoaded === "function") {
							self.options.onLoaded(results, self._context());
						}
					})
					.fail(function (jqXHR, textStatus, err) {
						// Ignore deliberate aborts caused by a new search
						if (textStatus === "abort") {
							return;
						}

						if (!append) {
							self._clearTargets();
							self._renderSelectOptions([]);
							self._hideResults();
						}

						self._showMessage("Address lookup failed. Please try again.");
						self._handleError(err || textStatus, { jqXHR: jqXHR });
					})
					.always(function () {
						self._setLoading(false);
						self._setResultsLoading(false);
						self._isLoadingMore = false;
					});
				},

				_extractResults: function (data) {
					if (Array.isArray(data)) {
						return data;
					}

					return (data && (data.results || data.addresses || data.items)) || [];
				},

				_extractHasMore: function (data, results, page) {
					if (data && typeof data.hasMore === "boolean") {
						return data.hasMore;
					}

					if (data && typeof data.total === "number") {
						var responsePage = data.page || page || this._currentPage || 1;
						var responsePageSize = data.pageSize || this.options.pageSize;
						return responsePage * responsePageSize < data.total;
					}

					// Fallback for old/simple response shapes.
					// If the backend returns a full page, assume there may be more.
					return results && results.length === this.options.pageSize;
				},

				_handleResultsScroll: function () {
					if (this._isLoadingMore || !this._hasMore || !this._lastSearchPayload) {
						return;
					}

					var el = this.$results[0];

					var nearBottom =
						el.scrollTop + el.clientHeight >=
						el.scrollHeight - this.options.scrollThresholdPx;

					if (!nearBottom) {
						return;
					}

					this._isLoadingMore = true;
					this._search(this._lastSearchPayload, this._currentPage + 1, true);
				},	
				
				_renderSelectOptions: function (results) {
					var self = this;

					this.$select.empty();

					this.$select.append($("<option/>", {
						value: "",
						text: "Select an address…"
					}));

					if (!results || !results.length) {
						return;
					}

					$.each(results, function (idx, r) {
						var label = self._formatOptionLabel(r);

						var $opt = $("<option/>", {
							value: String(idx),
							text: label
						});

						$opt.data("addressLookupResult", r);
						self.$select.append($opt);
					});
				},

				_renderResultsList: function (results, hasMore) {
					var self = this;

					this.$results.empty();

					if (!results || !results.length) {
						return;
					}

					$.each(results, function (idx, r) {
						var label = self._formatOptionLabel(r);

						var $row = $("<div/>", {
							"class": self.options.resultClass,
							"role": "option",
							"tabindex": "0",
							"data-address-lookup-index": idx
						});

						$row.text(label);
						$row.data("addressLookupResult", r);

						self.$results.append($row);
					});

					if (hasMore) {
						this.$results.append(
							$("<div/>", {
								"class": this.options.loadingClass,
								"text": "Scroll for more addresses…"
							})
						);
					}
				},

				_setResultsLoading: function (isLoading) {
					if (!this.$results || !this.$results.length) {
						return;
					}

					this.$results.toggleClass("is-loading", !!isLoading);

					if (isLoading && this._results && this._results.length) {
						var $loading = this.$results.find("." + this.options.loadingClass);

						if (!$loading.length) {
							this.$results.append(
								$("<div/>", {
									"class": this.options.loadingClass,
									"text": "Loading more addresses…"
								})
							);
						} else {
							$loading.text("Loading more addresses…");
						}
					}
				},	
				
				_handleResultClick: function (e) {
					var raw = $(e.currentTarget).data("addressLookupResult");
					this._selectAddress(raw);
				},

				_handleResultKeydown: function (e) {
					if (e.key === "Enter" || e.key === " ") {
						e.preventDefault();

						var raw = $(e.currentTarget).data("addressLookupResult");
						this._selectAddress(raw);
					}
				},										

				_handleSelectAddressChange: function () {
					var $selected = this.$select.find(":selected");

					// Placeholder selected
					if (!$selected.val()) {
						this._clearTargets();
						this._showSelect();
						return;
					}

					this._selectAddress($selected.data("addressLookupResult"));
				},
				
				_selectAddress: function (raw) {
					if (!raw) return;

					var mapped = this._mapResultToFields(raw);

					this._setValueById(this.targets.addressLine, mapped.addressLine);
					this._setValueById(this.targets.town, mapped.town);
					this._setValueById(this.targets.county, mapped.county);
					this._setValueById(this.targets.postcode, mapped.postcode);
          if (this.targets.uprn) {
             this._setValueById(this.targets.uprn, mapped.uprn);
          }

					if (mapped.latitude != null) {
						$(this.options.latSelector).val(mapped.latitude);
					}

					if (mapped.longitude != null) {
						$(this.options.lngSelector).val(mapped.longitude);
					}

					this._hideResults();
					this._hideSelect();
					this._hideMessage();

					if (typeof this.options.onSelected === "function") {
						this.options.onSelected(raw, this._context());
					}
				},

    _mapResultToFields: function (raw) {
      var coords = raw.coordinates || {};

      function joinParts(parts, separator) {
        return parts
          .map(function (part) {
            return (part || "").toString().trim();
          })
          .filter(Boolean)
          .join(separator);
      }

      function isBuildingNumber(value) {
        value = (value || "").toString().trim();

        // Treat common numeric building references such as "12", "12A",
        // "12-14" and "12A/12B" as numbers. Other values are assumed to
        // be property names and should be separated from the street by a comma.
        return /^\d+[a-z]?(?:\s*[-/]\s*\d+[a-z]?)?$/i.test(value);
      }

      function removeTrailingPart(value, part) {
        value = (value || "").toString().trim();
        part = (part || "").toString().trim();

        if (!value || !part) {
          return value;
        }

        var valueLower = value.toLowerCase();
        var partLower = part.toLowerCase();

        if (valueLower.slice(-partLower.length) === partLower) {
          return value
            .slice(0, -part.length)
            .replace(/[,\s]+$/, "");
        }

        // The suffix must match exactly, apart from case and whitespace.
        // If provider formats the value differently, it is left unchanged.
        // That may result in a duplicated town/postcode, so this is a useful
        // place to add logging if the formatting is inconsistent.
        return value;
      }

      function addressLineFromLocation(raw) {
        if (
          typeof raw.location !== "string" ||
          !raw.location.trim()
        ) {
          return "";
        }

        var line = raw.location.trim();

        // Current UK providers are expected to format location as:
        // "... address parts, Town, POSTCODE". Remove the suffix in reverse
        // order. Revisit this assumption before adding a provider that uses a
        // different address order.
        line = removeTrailingPart(
          line,
          raw.postcode
        );

        line = removeTrailingPart(
          line,
          raw.postTown || raw.town
        );

        return line;
      }

      var streetAndLocality = joinParts(
        [
          raw.street,
          raw.locality
        ],
        ", "
      );

      // A number belongs directly with its street ("12 High Street"), whereas
      // a named property is a separate address part ("Rose Cottage, High Street").
      // This also fixes the structured-field fallback when raw.location is absent.
      var primaryAndStreet = joinParts(
        [
          raw.primaryNameOrNumber,
          streetAndLocality
        ],
        isBuildingNumber(raw.primaryNameOrNumber) ? " " : ", "
      );

      var composedLine = joinParts(
        [
          raw.secondaryNameOrNumber,
          primaryAndStreet
        ],
        ", "
      );

      // Prefer the provider's formatted location when available, but retain the
      // independently formatted structured-field fallback for providers or
      // responses that don't populate the raw.location field.
      var locationAddressLine = addressLineFromLocation(raw);

      return {
        addressLine:
          locationAddressLine ||
          composedLine ||
          raw.addressLine ||
          raw.address ||
          "",
        town: raw.postTown || raw.town || "",
        county: raw.county || raw.administrativeArea || "",
        postcode: raw.postcode || "",
        uprn: raw.uprn || "",
        latitude: coords.latitude,
        longitude: coords.longitude
      };
    },

		_clearTargets: function () {
      // clear the mapped fields (uprn only when the form reserved a slot for it)
			this._setValueById(this.targets.addressLine, "");
			this._setValueById(this.targets.town, "");
			this._setValueById(this.targets.county, "");
			this._setValueById(this.targets.postcode, "");
      if (this.targets.uprn) {
         this._setValueById(this.targets.uprn, "");
      }

			// clear coordinates
			$(this.options.latSelector).val("");
			$(this.options.lngSelector).val("");
		},
		
		_showResults: function () {
			if (this.$results && this.$results.length) {
				this.$results.show();
			}
		},
		_hideSelect: function () {
				this.$select.css("display", "none");
				$('label[for="' + this.selectId + '"]').css("display", "none");
			},

			_showSelect: function () {
				this.$select.css("display", "");
				$('label[for="' + this.selectId + '"]').css("display", "");
				this.$select.closest(".form-group, .field, .row, .form-row").css("display", "");
			},
		_hideResults: function () {
			if (this.$results && this.$results.length) {
				this.$results.hide();
			}
		},
		
		_showMessage: function (msg) {
			var $input = $("#selectpostcode");
			var $inputGroup = $input.closest(".input-group");

			this.$messageBox = $('<div class="address-lookup-message" role="alert"></div>');

			this.$messageBox
			    .text(msg)
			    .show()
			    .insertAfter($inputGroup);
		},

		_hideMessage: function () {
			if (this.$messageBox && this.$messageBox.length) {
				this.$messageBox.hide().text("");
			}
		},

		_renderMessageOption: function (message) {
			this.$select.empty().append($("<option/>", {
				value: "",
				text: message,
			}));
		},

		_formatOptionLabel: function (r) {
		  // Prefer location if it is a non-empty string
		  var loc = (typeof r.location === "string" && r.location.trim()) ? r.location.trim() : null;

		  return loc || (
		    (r.addressLine || r.address || r.primaryNameOrNumber || "Address") +
		    (r.postcode ? (", " + r.postcode) : "")
		  );
		},
		
		_setPlaceholder: function (text) {
			this._defaultPlaceholder = this._defaultPlaceholder || (this.element.attr("placeholder") || "");
			this.element.attr("placeholder", text);
		},

		_restorePlaceholder: function () {
			if (this._defaultPlaceholder != null) {
				this.element.attr("placeholder", this._defaultPlaceholder);
			}
		},		

		_setValueById: function (id, value) {
			$("#" + id).val(value == null ? "" : value);
		},

		_setLoading: function (isLoading) {
			this.$button.prop("disabled", !!isLoading);
			this.$button.toggleClass("is-loading", !!isLoading);
		},

		_handleError: function (err, extra) {
			if (typeof this.options.onError === "function") {
				this.options.onError(err, $.extend({}, extra, this._context()));
				return;
			}
			// what shall we do when error occurs?
		},

		_context: function () {
			return {
				endpoint: this.endpoint,
				buttonId: this.buttonId,
				selectId: this.selectId,
				targets: this.targets,
			};
		},
	});


	$(function () {
		$("input[data-address-lookup]").each(function () {
			try {
				$(this).addressLookup();
			} catch (e) {
				console.error(e);
			}
		});
	});
})(jQuery);
